import moment from 'moment';
import { TFunction } from 'i18next';
import {
    IClientTimeToHireComparisonData,
    IClientTimeToHireJobData,
} from '../interfaces/reports.interfaces';
import {
    IReportPeriod,
    IJobMetricChartDatum,
    IComparisonChartDatum,
} from '../interfaces/reportChart.interfaces';
import {
    TIME_TO_HIRE_METRIC_KEYS,
    TIME_TO_HIRE_METRIC_LABELS,
    TIME_FRAME_OPTIONS,
} from '../consts/reports.consts';

export const getReportPeriodLabel = (
    data: IReportPeriod,
    t: TFunction
): string => {
    if (data.startDate && data.endDate) {
        return `${data.startDate} - ${data.endDate}`;
    }
    const option = TIME_FRAME_OPTIONS.find((o) => o.value === data.timeFrame);
    return t(option?.label || data.timeFrame || '');
};

export const getComparisonChartData = (
    data: IClientTimeToHireComparisonData,
    t: TFunction
): IComparisonChartDatum[] =>
    TIME_TO_HIRE_METRIC_KEYS.map((key) => {
        const entry: IComparisonChartDatum = {
            name: t(TIME_TO_HIRE_METRIC_LABELS[key]),
        };
        data.jobs.forEach((job) => {
            entry[job.jobTitle] = Math.round(job[key]?.averageDays ?? 0);
        });
        return entry;
    });

export const getJobMetricChartData = (
    data: IClientTimeToHireJobData,
    t: TFunction
): IJobMetricChartDatum[] =>
    TIME_TO_HIRE_METRIC_KEYS.map((key) => ({
        name: t(TIME_TO_HIRE_METRIC_LABELS[key]),
        days: Math.round(data[key]?.averageDays ?? 0),
    }));

export const formatDurationTick = (value: number): string => {
    if (value === 0) return '0';
    return moment.duration(value, 'days').humanize();
};
